export default __webpack_public_path__ + "static/media/sale4.f91a3821.png";